import { Tooltip } from "@mui/material";

const ResultInput = ({ label, value, isLast,tooltip }) => {
    return (
        <Tooltip title={tooltip}>

        <div className="flex flex-col pt- items-center w-full">
            <label className="text-chinese-black/70 font-medium font-medium text-[10px] sm:text-xs md:text-sm">{label}</label>
            <input className={`py-3 px-4 w-full bg-bright-gray/50 rounded-xl text-center ${isLast && "bg-primary/10 text-primary"}`} disabled value={value} />
        </div>
        </Tooltip>
    );
};

export default ResultInput;